import styled, { css } from 'styled-components/macro';
import { ReactComponent as Chevron } from '../assets/icons/chevron-down.svg';

export const PaginatorWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: auto;
  margin-bottom: 2rem;
`;

export const PageNumberH4 = styled.h4`
  height: 2.5rem;
  width: auto;
  color: ${props => props.theme.dustierGray};
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
  ${props =>
    props.previouslyVisited &&
    css`
      color: ${props => props.theme.black};
    `}
  ${props =>
    props.currentPage &&
    css`
      border: 1px solid black;
      color: black;
      z-index: 1;
    `}
  padding-left: 10px;
  padding-right: 10px;
  ${props =>
    !props.paginatorBreak &&
    css`
      cursor: pointer;
      &:hover {
        color: ${props => props.theme.blue};
      }
    `}
  user-select: none;
  -webkit-transform: translateZ(
    0
  ); /* for safari, otherwise fonts stack on hover */
`;

export const ChevronSvg = styled(Chevron)`
  width: 1rem;
  height: 1rem;
  margin-top: auto;
  margin-bottom: auto;
  user-select: none;
  cursor: pointer;
  ${props =>
    props.styled.chevronLeft &&
    css`
      margin-right: 20px;
      transform: rotate(90deg);
    `}
  ${props =>
    props.styled.chevronRight &&
    css`
      margin-left: 20px;
      transform: rotate(270deg);
    `}
  :hover {
    fill: ${props => props.theme.blue};
  }
`;
ChevronSvg.defaultProps = {
  styled: {}
};
